import store from "data/store";
import { Button, Collapse, Flex, Form, List, Segmented } from "antd";
import React, { Component } from "react";
import { Observer, observer } from "mobx-react";
import ChatsService from "services/chats";
import HistoryChatCard from "components/cards/historyCard";
import TAGS from "constants/tags";
import { HISTORY_CATEGORIES } from "constants/chats";
import { sortChats, filterByTag, filterByNameOrId } from "./utils";
import { Form as FinalForm, Field, FormSpy, OnChange } from "react-final-form";
import FormGroup from "components/form/formGroup";

const INITIAL_FILTERS = {
  tag: null,
  sort: "default",
  nameOrId: "",
};

const SORT_OPTIONS = HISTORY_CATEGORIES.map((c) => ({
  label: c,
  value: c,
}));

class HistoryChatsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: INITIAL_FILTERS,
      type: "paid",
    };
  }

  get activeChatsByType() {
    if (this.state.type === "paid") {
      return store.historyChats;
    } else if (this.state.type === "trial") {
      return store.trialChats;
    } else if (this.state.type === "archive") {
      return store.archivedHistoryChats;
    } else {
      return store.workSessionChats;
    }
  }

  get chatsByFilters() {
    const filters = [
      sortChats(this.state.filters.sort),
      filterByTag(this.state.filters.tag),
      filterByNameOrId(this.state.filters.nameOrId),
    ];

    return filters.reduce(
      (acc, fn) => fn(acc),
      this.activeChatsByType.items.toJSON()
    );
  }

  changeChatsType = (type) => this.setState({ type });

  changeFilters = (values) => this.setState({ filters: values });

  resetFilters = () => this.setState({ filters: INITIAL_FILTERS });

  render() {
    return (
      <Flex style={{ flex: 1 }} vertical>
        <Segmented
          style={{ padding: 10, alignSelf: "center" }}
          options={["paid", "trial", "archive", "work session"]}
          onChange={this.changeChatsType}
        />
        <Collapse>
          <Collapse.Panel header="Filters">
            <FinalForm
              onSubmit={this.changeFilters}
              initialValues={this.state.filters}
            >
              {() => (
                <Form layout="vertical">
                  <FormSpy
                    subscription={{ values: true, reset: true }}
                    onChange={(state) => this.changeFilters(state.values)}
                  />
                  <Field
                    component={FormGroup}
                    type="text"
                    label="Enter client name or id"
                    placeholder="Enter client name or id"
                    name="nameOrId"
                    allowClear
                  />
                  <Field
                    component={FormGroup}
                    type="select"
                    name="tag"
                    style={{ flex: 1 }}
                    placeholder="Select chats tag"
                    label="Select chats tag"
                    options={TAGS}
                    allowClear
                  />
                  <Field
                    component={FormGroup}
                    type="select"
                    name="sort"
                    style={{ flex: 1 }}
                    label="Sort chats by"
                    placeholder="Select sort"
                    options={SORT_OPTIONS}
                  />
                  <Form.Item>
                    <Button type="primary" danger onClick={this.resetFilters}>
                      Reset
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </FinalForm>
          </Collapse.Panel>
        </Collapse>
        <List
          dataSource={this.chatsByFilters}
          renderItem={(chat, index) => (
            <Observer>
              {() => (
                <HistoryChatCard
                  number={index + 1}
                  key={chat.id}
                  name={chat.contact.firstName || `User #${chat.contact.id}`}
                  onClick={() => ChatsService.selectChat(chat.id)}
                  active={store.activeChat?.id === chat.id}
                  message={
                    chat.isTyping ? "User is typing..." : chat.lastMessage?.text
                  }
                  unreadMessagesCount={chat.unreadMessagesCount}
                  startedAt={chat.startedAt}
                  isOnline={chat.isOnline}
                  isTrial={chat.isTrial}
                  paidMinutes={chat.paidMinutes}
                  tag={chat.tag}
                />
              )}
            </Observer>
          )}
        />
      </Flex>
    );
  }
}

export default observer(HistoryChatsPage);
